// extracted by mini-css-extract-plugin
export default {"buttons":"EmailDomainConfigContainer-buttons-11346768900853376f25f8bf4409ba99","editButton":"EmailDomainConfigContainer-editButton-fa26d6f7f49307b28bf2a8378c1ea4f8"};